import { render } from "./post-smtp-guide.vue?vue&type=template&id=7fb6e671&scoped=true"
import script from "./post-smtp-guide.vue?vue&type=script&lang=js"
export * from "./post-smtp-guide.vue?vue&type=script&lang=js"

import "./post-smtp-guide.vue?vue&type=style&index=0&id=7fb6e671&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fb6e671"]])

export default __exports__